var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('SectionIntro'),_c('SectionMission'),_c('SectionSolution'),_c('SectionPartner'),_c('SectionGovCollaboration'),_c('SectionNews'),_c('SectionMedia',{attrs:{"isGrayBackground":true}}),_c('SectionContactUs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }